export class FileThumbnail {
  url: string;
  blob: Blob;
  file: File;
  time?: number;
  source: 'auto' | 'custom';
}
